import $ from 'jquery'
import { getParams } from './utils';
const hostname = window.location.hostname;
export const arr = hostname.split(".");
export const isTest = +getParams('test') === 1 ? true : false;
if(isTest) {
  arr[1] = '37games';
}
export const EVENT_HOST = "gevents."+arr[1]+".com";
export const AID = 'pnskfsquadron';

const API_HOST = "gactivityapi." + arr[1] + ".com";
const baseUrl = `https://${API_HOST}/activity/execute?name=pnskfsquadron&action=`;
const loginUrl = `https://gpassport.${arr[1]}.com/center/ajax/get_user_json`;
const logoutUrl = `https://gpassport.${arr[1]}.com/web_login/logout`;
const getConfigUrl = `${baseUrl}getConfig`
const lotteryBookUrl = `${baseUrl}lotteryBook`;
const createGroupUrl = `${baseUrl}createGroup`;
const joinGroupUrl = `${baseUrl}joinGroup`;
const cancelGroupUrl = `${baseUrl}cancelGroup`;
const groupAwardUrl = `${baseUrl}groupAward`;
const getAwardTimesUrl = `${baseUrl}getAwardTimes`;
const lotteryAwardUrl = `${baseUrl}lotteryAward`;
const completeShareUrl = `${baseUrl}completeShare`;
const completeInviteUrl = `${baseUrl}completeInvite`;
const listAwardUrl = `${baseUrl}listAward`;
const serverUrl = `${baseUrl}listServer`;
const newServerUrl = `${baseUrl}listServerNew`;
const characterUrl = `${baseUrl}getMobileGameRole`;

const ajax = {
  request(param) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: param.method || 'get',
        url: param.url || '',
        data: param.data || '',
        dataType: param.type || 'jsonp',
        jsonp: 'callback',
        success: function (res) {
          resolve(res)
        },
        error: function (errMsg) {
          reject(errMsg)
        }
      })
    })
  }
}

export const api = {
  getConfig() {
    const params = {
      url: getConfigUrl
    }
    return ajax.request(params)
  },
  lotteryBook() {
    const params = {
      url: lotteryBookUrl
    }
    return ajax.request(params)
  },
  createGroup() {
    const params = {
      url: createGroupUrl
    }
    return ajax.request(params)
  },
  joinGroup({ group_code }) {
    const params = {
      url: joinGroupUrl,
      data: {
        params: JSON.stringify({
          group_code
        })
      }
    }
    return ajax.request(params)
  },
  cancelGroup() {
    const params = {
      url: cancelGroupUrl
    }
    return ajax.request(params)
  },
  groupAward({ server_id, role_id, role_name }) {
    const params = {
      url: groupAwardUrl,
      data: {
        params: JSON.stringify({
          server_id,
          role_id,
          role_name
        })
      }
    }
    return ajax.request(params)
  },
  getAwardTimes({ id, server_id, role_id, role_name }) {
    const params = {
      url: getAwardTimesUrl,
      data: {
        params: JSON.stringify({
          id,
          server_id,
          role_id,
          role_name
        })
      }
    }
    return ajax.request(params)
  },
  lotteryAward({ server_id, role_id, role_name }) {
    const params = {
      url: lotteryAwardUrl,
      data: {
        params: JSON.stringify({
          server_id,
          role_id,
          role_name
        })
      }
    }
    return ajax.request(params)
  },
  completeShare({ avatar_id }) {
    const params = {
      url: completeShareUrl,
      data: {
        params: JSON.stringify({
          avatar_id
        })
      }
    }
    return ajax.request(params)
  },
  completeInvite({ group_code, tag }) {
    const params = {
      url: completeInviteUrl,
      data: {
        params: JSON.stringify({
          group_code,
          tag
        })
      }
    }
    return ajax.request(params)
  },
  listAward() {
    const params = {
      url: listAwardUrl
    }
    return ajax.request(params)
  },
  checkLogin() {
    const params = {
      url: loginUrl
    }
    return ajax.request(params)
  },
  logout() {
    const params = {
      url: logoutUrl
    }
    return ajax.request(params)
  },
  getServer(gameId) {
    const params = {
      url: serverUrl,
      data: {
        params: JSON.stringify({
          gameId
        })
      }
    }
    return ajax.request(params)
  },
  getNewServer(gameId) {
    const params = {
      url: newServerUrl,
      data: {
        params: JSON.stringify({
          gameId
        })
      }
    }
    return ajax.request(params)
  },
  getCharacter(server_id) {
    const params = {
      url: characterUrl,
      data: {
        params: JSON.stringify({
          server_id
        })
      }
    }
    return ajax.request(params)
  }
}
